import { defineStore } from 'pinia'
import { compareDesc } from 'date-fns'

import { getTemplateData } from '@/utils/dom'
import type { PID } from '@/types/shopify/products'

export const usePidsStore = defineStore('pids', () => {
  const pids = getTemplateData<PID[]>('#json-pids') || []
  const fids = pids.filter(i => i.product_category === 'oatmeal')
  const fid = fids.sort((a, b) => compareDesc(new Date(a.active_at), new Date(b.active_at)))[0]

  return {
    pids,
    fids,
    fid
  }
})
